import { CapoPlugin } from "/home/runner/_work/back-office/back-office/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];